export default "__VITE_ASSET__8ea105ff__"